import { DataStoreImpl } from "./DataStoreImpl";
import { FilterStoreImpl } from "./FilterStoreImpl";
import { JobPanelStoreImpl } from "./JobPanelStoreImpl";
import { NotificationStoreImpl } from "./NotificationStoreImpl";
import { ReportStoreImpl } from "./ReportStoreImpl";
import { createHashHistory } from "history";
export class RootStoreImpl {
    constructor(serviceClient) {
        this.notificationStore = new NotificationStoreImpl(this);
        this.jobPanelStore = new JobPanelStoreImpl(this, serviceClient);
        this.dataStore = new DataStoreImpl(this, serviceClient);
        this.reportStore = new ReportStoreImpl(this, serviceClient);
        this.filterStore = new FilterStoreImpl(this);
        this.serviceClient = serviceClient;
        this.hashHistory = createHashHistory();
    }
}
